export default __webpack_public_path__ + "img/heart-select-animation.269b27ac.svg";